import styled from 'styled-components';

export const StyledRechartsComponent = styled.div`
  position: relative;

  & p {
    text-align: center;
  }
`;
export const StyledRechartsComponentItem = styled.div`
  margin-bottom: 16px;
`;
